import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faFileUpload } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import starimg from '../../public/customerstar.jpg';

const SalesCustomerDetails = () => {
  const [customersData, setCustomersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomersData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        const email = user.email
        const response = await axios.post('https://citi-mobile-app.onrender.com/saleagent/agents', { email });

        if (response.data.fullDetails) {
          setCustomersData(response.data.fullDetails);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching customer data:', error);
        setLoading(false);
      }
    };

    fetchCustomersData();
  }, []);

  const handleViewAccount = (user) => {
    navigate(`/SalesCustomerDetails/ViewCustomer/${user._id}`);
  };

  const handleBulkorder = (user) => {
    navigate(`/SalesCustomerDetails/OrderBulk/${user._id}`);
  };

  if (loading) {
    return <div>Loading...</div>; // Show a loading icon while fetching data
  }

  return (
    <div className=" lg:ml-60 max-sm:w-screen lg:max-w-[80%] mt-16">
      {/* Header Section */}
      <h1 className="text-[#1E1E1E] font-bold mb-8 lg:mb-16 text-lg lg:text-2xl">Customer List</h1>

      <div className="bg-[#FFFFFF] rounded-md mb-6 px-3 py-3">
        <div className="flex flex-col lg:flex-row justify-between items-center mb-6">
          <div>
            <h1 className="lg:text-2xl font-bold">All customer-related information in one place</h1>
            <p className="text-gray-600 text-sm lg:text-base">Easily manage customer details, view order history, and segment customers into groups.</p>
          </div>
          <img src={starimg} className="w-24 h-24 lg:w-32 lg:h-32 mt-4 lg:mt-0" alt="Customer Star" />
        </div>

        {/* Buttons Section */}
        <div className="flex flex-col lg:flex-row gap-2">
          <Link to="/SalesCustomerDetails/AddCustomer" className="bg-blue-600 text-white py-2 px-4 rounded flex items-center justify-center lg:justify-start max-sm:w-screen">
            <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
            Add customer details
          </Link>
          <Link to="/SalesCustomerDetails/ImportCustomerDetails" className="border border-blue-600 text-blue-600 py-2 px-4 rounded flex items-center justify-center lg:justify-start">
            <FontAwesomeIcon icon={faFileUpload} className="mr-2" />
            Bulk upload customer details
          </Link>
        </div>
      </div>

      {/* Customer Details Table */}
      <div className="bg-white shadow-md p-3 rounded-md overflow-auto lg:max-h-[400px]">
        <h1 className="text-[#1E1E1E] font-bold mb-5 text-lg lg:text-xl">Customer List</h1>

        <table className="table-auto text-left whitespace-no-wrap w-full">
          <thead>
            <tr className="bg-[#F8F8F8] text-gray-600 text-sm uppercase w-full">
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">No</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Customer Name</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Store Name</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">State</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Phone number</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Store Type</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Assigned Agent</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Weekly Purchase</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Created At</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">View</th>
              <th className="px-2 py-2 text-[#1E1E1E] font-bold">Bulk Order</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm">
            {customersData.map((user, index) => (
              <tr key={user.customerDetails.id} className="border-b border-gray-200">
                <td className="px-2 py-2 text-[#1E1E1E]">{index + 1}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.firstName} {user.customerDetails.lastName}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.storeName}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.state}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.phoneNumber}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.storeType}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.fieldagent}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.potentialpurchase}</td>
                <td className="px-2 py-2 text-[#1E1E1E]">{user.customerDetails.createdAt}</td>
                <td className="px-2 py-2 text-blue-600">
                  <button onClick={() => handleViewAccount(user.customerDetails)}>
                    View account
                  </button>
                </td>
                <td className="px-2 py-2 text-blue-600">
                  <button onClick={() => handleBulkorder(user.customerDetails)}>
                    Bulk
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalesCustomerDetails;
